import { render, staticRenderFns } from "./CreateGoodsMarket.vue?vue&type=template&id=12e7a29a"
import script from "./CreateGoodsMarket.vue?vue&type=script&lang=js"
export * from "./CreateGoodsMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports